import * as core from '../../../../../../../core'

import { query } from './estimated-cursor-cost.query'

export const RESOURCE = {
  payload: {
    alias: 'estimated.cursor.cost',
    description:
      'Total estimated cost of recorded Cursor usage. Not yet implemented.',
    name: 'Estimated Cursor Cost',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
